module.exports = __webpack_public_path__ + "assets/img/img97.b0a45dbb.png";